import HubSpotDealModalPicker from "components/Picker/HubSpotDealPicker/HubSpotDealModalPicker";
import React from "react";
import { CustomSection } from "components/MainSectionTemplate/types";

import GenericHubSpotPanel from "HubSpot/GenericHubSpotPanel";

type Manual = {
  onChange: (id: number) => void
  value: number
}

type Autolink = {
  hubSpotDealId: number;
  clientId: number
}

interface Props {
  type: Manual | Autolink
}

const isManual = (type: Manual | Autolink): type is Manual => {
  return (type as Manual).onChange !== undefined;
}

export const HubSpotDealPanel = (props: Props) => {
  let clientId: number;
  let initialHubSpotId: number;
  if (!isManual(props.type)) {
    clientId = props.type.clientId;
    initialHubSpotId = props.type.hubSpotDealId;
  }


  return <GenericHubSpotPanel
    initialHubSpotId={initialHubSpotId}
    urlToHubSpotEntity={(id) => `https://app.hubspot.com/contacts/5257648/record/0-3/${id}/`}
    title="HubSpot"
    apiKey="hubspot-deal-section"
    fetch={window.CoreApi.HubSpot.GetDeal}
    link={isManual(props.type) ? {
      type: "manual",
      onChange: props.type.onChange,
      value: props.type.value,
    } : {
      type: "autolink",
      link: id => window.CoreApi.Client.SetHubSpotDealId({ clientId: clientId, hubSpotDealId: id }),
      unlink: () => window.CoreApi.Client.SetHubSpotDealId({ clientId: clientId, hubSpotDealId: null })
    }}
    create={{
      api: () => window.CoreApi.HubSpot.CreateDeal({ systemOneClientId: clientId }),
      createButtonLabel: "Create"
    }}
    renderPicker={onLink =>
      <HubSpotDealModalPicker
        value={null}
        required={isManual(props.type)}
        canCreateNew={false}
        validatorKey="hubSpotDeal"
        onChange={v => onLink(v.id)}
      />
    }

    dataFields={hsDeal => [
      {
        key: "hubSpotName",
        label: "Name",
        render: () => <div>{hsDeal.dealName}</div>,
      }, {
        key: "hubSpotStage",
        label: "Stage",
        render: () => <div>{hsDeal.stageLabel}</div>,
      }
    ]}
  />
}

export const hubSpotDealPanelSection = (hubSpotDealId: number, clientId: number): CustomSection => {
  return {
    key: "hubSpotDealPanel",
    type: "custom",
    render: () => <HubSpotDealPanel
      key="hubSpotDealPanel"
      type={{
        hubSpotDealId,
        clientId
      }}
    />
  }
}